import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NgbDate, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import moment from 'moment';
import { timeZone } from '../../../../core/routing/constants/timeZone.constant';
import { GlobalConstants } from '../../../constants/global.constant';
import { CommonService } from 'src/app/common/services/common.service';
import { distinctUntilChanged } from 'rxjs/operators';
import { RouterConstants } from 'src/app/core/routing/constants/app-paths.constant';
import { Router } from '@angular/router';

@Component({
  selector: 'iposcen-date-time-zone',
  templateUrl: './date-time-zone.component.html',
  styleUrls: ['./date-time-zone.component.scss']
})
export class DateTimeZoneComponent implements OnInit {
  @Input() publishDateInfo: string;
  @Input() expiryDateInfo: string;
  @Input() divideDate: boolean;
  @Input() hideCalendar: boolean;
  @Output() currentDateTime = new EventEmitter<string>();
  @Output() selectedDateTime = new EventEmitter<any>();
  @Output() getDateTimeZoneData = new EventEmitter<any>();
  @Output() errorMessageTime = new EventEmitter<any>();
  @Output() isTimeZoneSelected = new EventEmitter<boolean>();
  @Output() defualtTimeZone = new EventEmitter<any>();
  @Input() isPushPackageHours: boolean;
  @Input() isAttractLoop: boolean;
  ifTimePicked = false
  ifTimezonePicked = false
  datetimePickerFrm: FormGroup;
  timeZone = [] as any;
  timeHoursConstant = [] as any;
  timeMinuteConstant = [] as any;
  dateRes = [] as any;
  dateObj = {} as any;
  minDate = {} as any;
  hourVal: string;
  minuteVal: string;
  timeZoneVal: string;
  expiryDateTime: string;
  isExpiredDateIncorrect: boolean;
  customDate: any;
  toDate: NgbDate;
  direction: string;
  placement: string;
  searchPlaceholderText: string = 'yyyy-mm-dd';
  valueForTimeZone: any;
  timeZoneText: string;
  dateModel: NgbDateStruct;
  isProfilePage = false;
  @ViewChild('selected') hrDropDown: ElementRef;
  @ViewChild('selected2') minDropDown: ElementRef;
  pushPackageHourVal: any;
  pushPackageMinuteVal: any;
  pushPackageDateVal: any;

  constructor(private formBuilder: FormBuilder,
    private cmnService: CommonService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.direction = this.cmnService.direction;
    this.placement = this.direction === "rtl" ? 'bottom-left' : 'bottom-right';
    this.getTimeZoneData();
    if (this.isPushPackageHours) {
      let date = new Date();
      const updateTime = new Date(date.getTime() + 30 * 60000);
      const updatedHours = updateTime.getHours();
      const updatedMinutes = updateTime.getMinutes();
      this.pushPackageHourVal = updatedHours < 10 ? '0' + updatedHours : updatedHours;
      if (typeof this.pushPackageHourVal === 'string') {
        this.pushPackageHourVal = Number(this.pushPackageHourVal);
      }
      this.pushPackageMinuteVal = updatedMinutes < 10 ? '0' + updatedMinutes : updatedMinutes;
      if (typeof this.pushPackageMinuteVal === 'string') {
        this.pushPackageMinuteVal = Number(this.pushPackageMinuteVal);
      }
    }
    this.hourVal = '00';
    this.minuteVal = '00';
    this.timeZoneVal = '';
    this.getSystemTimeZone();
    this.expiryDateTime = '';
    this.createDateTimePickerFrm();
    this.createConstantData();
    this.editDateInfo();
    this.dateObj = {
      dateVal: (this.datetimePickerFrm.controls.publishedTimeStamp.value) ?
        this.setDatePickerval(this.datetimePickerFrm.controls.publishedTimeStamp.value) : '',
      hour: this.isPushPackageHours ? this.pushPackageHourVal : '00',
      min: this.isPushPackageHours ? this.pushPackageMinuteVal : '00',
      timeZone: GlobalConstants.TIME_ZONE
    };
    if (this.router.url.includes(GlobalConstants.PROFILE_IPOS)) {
      this.isProfilePage = true;
    }
    //If only profile/Device push - assigning PST TIME ZONE
    if (this.hideCalendar) {
      this.dateObj.timeZone = GlobalConstants.PST_TIME_ZONE;
    }
    const current = new Date();
    this.minDate = {
      year: current.getFullYear(),
      month: current.getMonth() + 1,
      day: current.getDate()
    };
    this.datetimePickerFrm.get("time").valueChanges.pipe(distinctUntilChanged()).subscribe(x => {
      this.getSelectTime(x);
    })
    this.timeZoneText = GlobalConstants.TIME_ZONE;
  }

  getSystemTimeZone() {
    if (this.hideCalendar) {
      this.timeZoneVal = GlobalConstants.PST_TIME_ZONE;
    } else {
      const today = new Date();
      const timeZoneObjInfo = today.toTimeString().slice(9);
      const timeZoneInfo = timeZoneObjInfo.split('(')[1].replace(/[{()}]/g, '');
      timeZone.forEach(element => {
        if (element.name === timeZoneInfo) {
          this.timeZoneVal = element.value;
        }
      });
      if (this.timeZoneVal === '') {
        this.timeZoneVal = GlobalConstants.TIME_ZONE;
      }
    }
    this.valueForTimeZone = this.timeZoneVal;
    this.defualtTimeZone.emit(this.valueForTimeZone);
  }

  getPublishORExpDates(DateInfo) {
    let fullPublishDate = DateInfo.split(' ');
    let timeInfo = DateInfo.split(' ')[1].split(':');
    this.customDate = moment(`${fullPublishDate[0]}`).format('YYYY/MM/DD');
    let year = this.customDate.split('/')[0];
    let month = this.customDate.split('/')[1];
    let day = this.customDate.split('/')[2];
    this.dateModel = { year: Number(year), month: Number(month), day: Number(day) };
    this.datetimePickerFrm.controls['time'].setValue({
      hour: parseInt(timeInfo[0]),
      minute: parseInt(timeInfo[1])
    });
  }

  editDateInfo() {
    if (this.isPushPackageHours && this.publishDateInfo && this.publishDateInfo !== GlobalConstants.NOW) {
      this.getPublishORExpDates(this.publishDateInfo);
      this.datetimePickerFrm.controls.time.setValue({
        hour: this.pushPackageHourVal,
        minute: this.pushPackageMinuteVal
      });
      this.gotoParent();
    }
    if (this.publishDateInfo && this.publishDateInfo !== GlobalConstants.NOW && !this.isPushPackageHours) {
      this.getPublishORExpDates(this.publishDateInfo);
      this.timeZoneVal = this.getTimeZoneString(this.publishDateInfo);
    }
    if (this.expiryDateInfo && this.expiryDateInfo !== GlobalConstants.NEVER) {
      this.getPublishORExpDates(this.expiryDateInfo);
      this.timeZoneVal = this.getTimeZoneString(this.expiryDateInfo);
    }
    if (this.hideCalendar) {
      this.valueForTimeZone = GlobalConstants.PST_TIME_ZONE;
    } else {
      this.valueForTimeZone = this.timeZoneVal;
    }
  }

  createConstantData() {
    for (let hour = 0; hour < 24; hour++) {
      const timeHour = hour.toString().length < 2 ? '0' + hour : hour.toString();
      this.timeHoursConstant.push(timeHour);
    }
    for (let min = 0; min < 60; min++) {
      const timeMin = min.toString().length < 2 ? '0' + min : min.toString();
      this.timeMinuteConstant.push(timeMin);
    }
  }

  getTimeZoneString(dateString: string) {
    let dateVal = dateString.split(GlobalConstants.DATEFORMAT_SPACE_REGEX);
    let tz_offset = dateVal[1].split(GlobalConstants.DATEFORMAT_SPACE_REGEX)[1];
    return tz_offset;
  }

  createDateTimePickerFrm() {
    this.datetimePickerFrm = this.formBuilder.group({
      publishedTimeStamp: new FormControl(''),
      hourBtn: new FormControl(''),
      minuteBtn: new FormControl(''),
      timeZoneBtn: new FormControl(''),
      time: {
        hour: this.isPushPackageHours ? this.pushPackageHourVal : 0,
        minute: this.isPushPackageHours ? this.pushPackageMinuteVal : 0
      }
    });
  }

  getTimeZoneData() {
    timeZone.forEach(element => {
      const timeZoneList = {
        timeZoneValue: element.value,
        offset: element.offset
      };
      this.timeZone.push(timeZoneList);

    });
    this.timeZone = this.timeZone.slice()
      .sort((sort1, sort2) => sort2.offset - sort1.offset);
  }

  getCurrentTime() {
    const today = new Date();
    const dd = today.getDate();
    const mm = today.getMonth() + 1;
    const yyyy = today.getFullYear();
    const hour = today.getHours();
    const minute = today.getMinutes();
    const dateInfo = `${mm}/${dd}/${yyyy}`;
    const time = `${hour}:${minute}`;
    let timeZone = today.toTimeString().slice(9);

    if (timeZone.length > 30) {
      timeZone = timeZone.substring(0, 30);
      timeZone = `${timeZone}...`;
    }
    const currentDateResult = `${dateInfo} ${time} ${timeZone}`;
    this.currentDateTime.emit(currentDateResult);
  }

  getSelectedTime() {
    const dateVal = this.datetimePickerFrm.controls.publishedTimeStamp.value;
    const hourData = this.datetimePickerFrm.controls.time.value.hour.toString();
    const minuteData = this.datetimePickerFrm.controls.time.value.minute.toString();
    let timeZone = this.timeZoneVal;

    if (timeZone.length > 30) {
      timeZone = timeZone.substring(0, 30);
      timeZone = `${timeZone}...`;
    }
    if (dateVal !== '' && hourData !== '00' && timeZone !== '00') {
      const formattedDate = moment(dateVal).format(GlobalConstants.DATE_FORMAT);
      const selectedDateResult = `${formattedDate} ${hourData}:${minuteData}`;
      const selectedTimeZoneResult = timeZone;
      this.dateRes.push(selectedDateResult);
      this.dateRes.push(selectedTimeZoneResult);
      this.selectedDateTime.emit(this.dateRes);
    }
  }

  gotoParent() {
    const appendZeroForSingleDigit = (i: number): string => i < 10 ? `0${i}` : `${i}`;
    this.dateObj.hour = appendZeroForSingleDigit(this.datetimePickerFrm.controls.time.value.hour.toString());
    this.dateObj.min = appendZeroForSingleDigit(this.datetimePickerFrm.controls.time.value.minute.toString());
    if (this.isPushPackageHours) {
      this.dateObj.timeZone = (this.dateObj.timeZone === '') || (this.dateObj.timeZone === undefined) ? this.timeZoneVal : this.dateObj.timeZone;
      this.dateObj.dateVal = (this.dateObj.dateVal === '') || (this.dateObj.dateVal === undefined) ? this.setDatePickerval(this.dateModel) : this.dateObj.dateVal;
    }
    this.getDateTimeZoneData.emit(this.dateObj);
  }

  getSelectedTimeZone(e) {
    if (e === undefined) {
      this.timeZoneVal = '';
      this.isTimeZoneSelected.emit(false)
    } else {
      this.isTimeZoneSelected.emit(true)
      this.ifTimezonePicked = true;
      this.errorMessageTime.emit([this.ifTimePicked, this.ifTimezonePicked]);
      this.timeZoneVal = e.timeZoneValue;
      this.dateObj.timeZone = e.timeZoneValue;
      if (this.datetimePickerFrm.controls.publishedTimeStamp.value) {
        this.dateObj.dateVal = this.setDatePickerval(this.datetimePickerFrm.controls.publishedTimeStamp.value);
        this.dateObj.min = this.datetimePickerFrm.controls.time.value.minute.toString();
        this.dateObj.hour = this.datetimePickerFrm.controls.time.value.hour.toString();
        this.gotoParent();
      } else if (this.dateObj.dateVal !== '' && this.dateObj.dateVal.length) {
        this.gotoParent();
      } else if (this.hideCalendar) {
        this.gotoParent();
      }
    }
  }

  setDatePickerval(date) {
    return (date === undefined) ? '' : ((date !== '') ? `${date.month} ${date.day} ${date.year}` : date);
  }

  getSelectTime(time) {
    this.datetimePickerFrm.controls.time.setValue({
      hour: time?.hour,
      minute: time?.minute
    }, { onlySelf: true, emitEvent: false })
    this.checkDateTimeValue();
  }

  checkDateTimeValue() {
    if (this.datetimePickerFrm.controls.publishedTimeStamp.value) {
      this.dateObj.dateVal = `${this.datetimePickerFrm.controls.publishedTimeStamp.value.month} ${this.datetimePickerFrm.controls.publishedTimeStamp.value.day} ${this.datetimePickerFrm.controls.publishedTimeStamp.value.year}`;
    }
    if (this.timeZoneVal !== GlobalConstants.TIME_ZONE) {
      this.dateObj.timeZone = this.timeZoneVal;
    }
    this.dateObj.hour = this.datetimePickerFrm.controls.time.value.hour.toString();
    this.dateObj.min = this.datetimePickerFrm.controls.time.value.minute.toString();
    if (this.dateObj.dateVal !== '' && this.dateObj.timeZone !== GlobalConstants.TIME_ZONE) {
      this.gotoParent();
    } else if (this.hideCalendar && this.dateObj?.timeZone !== GlobalConstants.TIME_ZONE) {
      this.gotoParent();
    }
  }

  checkDate(data) {
    this.ifTimePicked = true;
    this.errorMessageTime.emit([this.ifTimePicked, this.ifTimezonePicked]);
    this.dateObj.dateVal = `${data.month} ${data.day} ${data.year}`;
    if (this.timeZoneVal.length && this.timeZoneVal !== GlobalConstants.TIME_ZONE) {
      this.dateObj.timeZone = this.timeZoneVal;
      this.dateObj.min = this.datetimePickerFrm.controls.time.value.minute.toString();
      this.dateObj.hour = this.datetimePickerFrm.controls.time.value.hour.toString();
      this.gotoParent();
    }
  }

}
